/**
 * Обратный отсчёт до момента until (мс, Date.now()) с шагом 1 с (KAN-601).
 * Возвращает оставшиеся секунды; 0, когда ожидание закончилось или не задано.
 */
import { useEffect, useState } from 'react';

export function useCountdown(until: number | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (until === null) return undefined;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [until]);

  if (until === null) return 0;
  return Math.max(0, Math.ceil((until - now) / 1000));
}
